import { Hero } from "../sections/Hero";
import { Marquee } from "../sections/Marquee";
import { WhySteel } from "../sections/WhySteel";
import { WhyModors } from "../sections/WhyModors";
import { ProductsPreview } from "../sections/ProductsPreview";
import { SectionDiagram } from "../sections/SectionDiagram";
import { Manufacturing } from "../sections/Manufacturing";
import { AboutStrip } from "../sections/AboutStrip";
import { Applications } from "../sections/Applications";
import { Quality } from "../sections/Quality";
import { DealerCTA } from "../sections/DealerCTA";
import { ContactSection } from "../sections/ContactSection";

export default function Home() {
  return (
    <main>
      <Hero />
      <Marquee />
      <WhySteel />
      <WhyModors />
      <ProductsPreview />
      <SectionDiagram />
      <Manufacturing />
      <AboutStrip />
      <Applications />
      <Quality />
      <DealerCTA />
      <ContactSection />
    </main>
  );
}
